import React from "react";
import { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
// import classnames from 'classnames';

const BoxenAbholen = (props, dropdown) => {
  const [boxOrders, setBoxOrders] = useState([]);
  const [updateBoxTable, setUpdateBoxTable] = useState(false);
  const [collectedboxs, setCollectedBoxs] = useState([]);
  const [boxProblemtextareaValue, setBoxProblemtextareaValue] = useState();
  const [boxproblemInvoiceId, setBoxProblemInvoiceId] = useState(0);
  const [boxmultipleorderIds, setboxMultipleorderIds] = useState([]);

  //start of Modal realated states and function
  const {
    // buttonLabel,
    className,
  } = props;

  const [boxProblemmodal, setBoxProblemmodal] = useState(false);
  const boxProblemtoggle = () => setBoxProblemmodal(!boxProblemmodal);

  const [nestedModal, setNestedModal] = useState(false);
  const [boxImageSrc, setBoximageSrc] = useState();
  const BoxtoggleNested = (imgSrc) => {
    setNestedModal(!nestedModal);
    setBoximageSrc(imgSrc);
  };

  //start of boxAlertModal realated states and function
  const [boxalertModal, setboxAlertModal] = useState(false);
  const boxalertToggle = () => setboxAlertModal(!boxalertModal);

  const [PmodalBoxProblemList, setPmodalBoxProblemList] = useState([]);
  const [boxpProblemDetailInvoiceId, setboxpProblemDetailInvoiceId] =
    useState();
  const [boxPupdateTriger, setPUpdateTriger] = useState(false);

  const [boxPmodal, setBoxPModal] = useState(false);
  const boxtoggleP = () => setBoxPModal(!boxPmodal);

  const boxProblemsdetailsHandler = (data) => {
    // for (let i = 1; i <= data.problems.length; i++) {
    //      element.push(data.problems[i]);
    //     setmodalProblemList(element)
    // }
    setPmodalBoxProblemList(data.problems);
    setboxpProblemDetailInvoiceId(data.invoiceId);
  };

  const boxsolvePHandler = (problem, problemId, problemDesc, index) => {
    const ProblemSolved = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${boxpProblemDetailInvoiceId}/${problemId}`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              solved: true,
              Description: problemDesc,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setPUpdateTriger(!boxPupdateTriger);
          let toRemove = problem;
          let index = PmodalBoxProblemList.indexOf(toRemove);
          if (index > -1) {
            //Make sure item is present in the array, without if condition, -n indexes will be considered from the end of the array.
            PmodalBoxProblemList.splice(index, 1);
            // if (index === 0) {
            //   boxtoggleP()
            // }
          }
          let counterOfProblem = 0;
          PmodalBoxProblemList.forEach(function (arraItem) {
            // Expected '===' and instead saw '=='
            if (arraItem.solved === false) {
              ++counterOfProblem;
            }
          });
          if (counterOfProblem < 1) {
            boxtoggleP();
          }
          // console.log(PmodalBoxProblemList);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    ProblemSolved();
  };

  const fetcBoxcollectedApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/boxToCollect/${props.dropdown}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setBoxOrders(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const boxCollectedokHandler = (invoice, data) => {
    if (data.invoiceIdsInOrder.length > 1) {
      // alert("this order has more than 1 item. \n" + " " + "it contains following order ids: \n" + data.invoiceIdsInOrder);
      setboxMultipleorderIds(data.watchIdsInOrder);
      boxalertToggle();
    }
    const boxCollectedPost = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/status/${invoice}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              StatusName: "boxcollected",
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setUpdateBoxTable(!updateBoxTable);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    boxCollectedPost();
  };

  const fetchBoxPhisicallyCollectedApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/boxcollected/${props.dropdown}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setCollectedBoxs(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleBoxTextareaChange = (event) => {
    setBoxProblemtextareaValue(event.target.value);
  };

  const boxProblemInvoiceIdHandler = (invoiceID) => {
    setBoxProblemInvoiceId(invoiceID);
    // console.log(boxproblemInvoiceId);
  };

  const boxProblemHandler = async (e) => {
    // e.preventDefault()
    if (boxProblemtextareaValue !== null) {
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${boxproblemInvoiceId}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              Description: boxProblemtextareaValue,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setUpdateBoxTable(!updateBoxTable);
          setBoxProblemtextareaValue(null);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert("Error "+ response.status + "\n" + "request was not successful" + "\n\n" + payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    }
  };

  useEffect(() => {
    fetcBoxcollectedApi();
    fetchBoxPhisicallyCollectedApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    updateBoxTable,
    props.dropdown,
    props.watchCollectProblem,
    boxPupdateTriger,
  ]);
  return (
    <Row>
      <Col sm="12">
        <div>
          <p>
            Noch abzuholen: <strong>{boxOrders.length}</strong> Boxen von{" "}
            {boxOrders.length + collectedboxs.length}
          </p>
          <Table bordered striped hover>
            <thead>
              <tr>
                <th>Lagerort</th>
                <th>Digits</th>
                <th>Auftrag</th>
                <th>Bild</th>
                <th>Bezeichnung</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {boxOrders.map((data, index) => {
                return (
                  <tr key={index}>
                    <th scope="row">{data.locationOfBox}</th>
                    <td>
                      {data.statusDbDigit}{" "}
                      {data.hasProblem ? (
                        <i
                          onClick={() => {
                            boxtoggleP();
                            boxProblemsdetailsHandler(data);
                          }}
                          id="problem"
                          className="fas fa-exclamation-circle"
                        ></i>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{data.orderId}</td>
                    <td>
                      <img
                        onClick={() => {
                          BoxtoggleNested(data.boxPhotoPath);
                        }}
                        className="ordeImgs"
                        src={data.boxPhotoPath}
                        alt="img"
                      />
                    </td>
                    <td>{data.saleTitle}</td>
                    <td
                      style={
                        data.invoiceIdsInOrder.length > 1
                          ? { backgroundColor: "#ffc107" }
                          : {}
                      }
                    >
                      <div
                        className="displayFlex"
                        style={{ justifyContent: "space-around" }}
                      >
                        <Button
                          color="primary"
                          onClick={() => {
                            boxCollectedokHandler(data.invoiceId, data);
                          }}
                        >
                          OK
                        </Button>{" "}
                        <div>
                          <Button
                            color="danger"
                            className="ml-3"
                            onClick={() => {
                              boxProblemtoggle();
                              setBoxProblemtextareaValue(null);
                              boxProblemInvoiceIdHandler(data.invoiceId);
                            }}
                          >
                            Problem
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tbody>
              {collectedboxs.length > 0 && (
                <tr className="tbodyDivider">
                  <th colSpan="6">
                    Eingesammelt: {collectedboxs.length} Boxen
                  </th>
                </tr>
              )}
              {collectedboxs.map((collectedBox, index) => {
                return (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: "#00FA9A	",
                      color: "#212529",
                      opacity: "0.8",
                    }}
                  >
                    <th scope="row">{collectedBox.locationOfBox}</th>
                    <td>
                      {collectedBox.statusDbDigit}{" "}
                      {collectedBox.hasProblem ? (
                        <i
                          id="problem"
                          className="fas fa-exclamation-circle"
                        ></i>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{collectedBox.orderId}</td>
                    <td>
                      <img
                        onClick={() => {
                          BoxtoggleNested(collectedBox.boxPhotoPath);
                        }}
                        className="ordeImgs"
                        src={collectedBox.boxPhotoPath}
                        alt="img"
                      />
                    </td>

                    <td>{collectedBox.saleTitle}</td>
                    <td
                      style={
                        collectedBox.invoiceIdsInOrder.length > 1
                          ? { backgroundColor: "#ffc107" }
                          : {}
                      }
                    ></td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Col>
      <Modal
        size="lg"
        centered={true}
        isOpen={boxProblemmodal}
        toggle={boxProblemtoggle}
        className={className}
      >
        <ModalHeader toggle={boxProblemtoggle}>Problem melden</ModalHeader>
        <ModalBody>
          <textarea
            style={{ width: "100%", height: "100px" }}
            onChange={handleBoxTextareaChange}
          ></textarea>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              boxProblemHandler();
              boxProblemtoggle();
            }}
          >
            Problem speichern
          </Button>{" "}
          <Button color="secondary" onClick={boxProblemtoggle}>
            Abbrechen
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={boxalertModal}
        centered={true}
        toggle={boxalertToggle}
        className={className}
      >
        <ModalHeader toggle={boxalertToggle}>
          Achtung! Auftrag enthält mehrere Bestellungen.
        </ModalHeader>
        <ModalBody>
          <p>
            Dieser Auftrag beinhaltet mehrere Bestellungen. Bitte Boxen aus dem
            Auftrag gemeinsam einsortieren.
            <br />
            Interne Nummern in diesem Auftrag:
          </p>
          {
            <ul>
              {boxmultipleorderIds.map((txt, index) => (
                <li key={index}>
                  <b>{txt}</b>
                </li>
              ))}
            </ul>
          }
        </ModalBody>
        <ModalFooter>
          <Button
            color="warning"
            style={{ color: "#212529" }}
            onClick={boxalertToggle}
          >
            OK
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        centered={true}
        isOpen={nestedModal}
        toggle={BoxtoggleNested}
        // onClosed={closeAll ? toggle : undefined}
      >
        {/* <ModalHeader>Nested Modal title</ModalHeader> */}
        <ModalBody>
          <img className="nestedImage" src={boxImageSrc} alt="Box" />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={BoxtoggleNested}>
            OK
          </Button>{" "}
          {/* <Button color="secondary" onClick={toggleAll}>All Done</Button> */}
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        centered={true}
        isOpen={boxPmodal}
        toggle={boxtoggleP}
        className={className}
      >
        <ModalHeader toggle={boxtoggleP}>Problemdetails</ModalHeader>
        <ModalBody>
          <div>
            <ol
              style={{ maxHeight: "300px", overflow: "auto", paddingLeft: "0" }}
            >
              {PmodalBoxProblemList.map((problem, index) => {
                if (!problem.solved) {
                  return (
                    <div
                      key={index}
                      // style={ (solvedClicked && solvedClickedIndex === index) ? { display: "none"} : {}}
                    >
                      <li
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "space-between",
                          marginRight: "10px",
                        }}
                      >
                        <p>
                          <span style={{ paddingRight: "16px" }}>
                            <b>{problem.personName}:</b>
                          </span>
                          {problem.description}
                        </p>
                        {/* {modalProblemList} */}
                        <Button
                          color="success"
                          className="ml-3"
                          onClick={() => {
                            boxsolvePHandler(
                              problem,
                              problem.id,
                              problem.description,
                              index
                            );
                          }}
                        >
                          Problem gelöst
                        </Button>
                      </li>
                      <hr></hr>
                    </div>
                  );
                }
                return null;
              })}
            </ol>
          </div>
          {/* <textarea style={{ width: '100%', height: '100px' }} placeholder="In case of new problem, please write your comment here"
                        onChange={handleProblemTextareaChange}
                        autoFocus={true} ></textarea> */}
        </ModalBody>
        {/* <ModalFooter style={{ justifyContent: "space-between" }}>
                    <Button color="primary" onClick={() => { updateProblemHandler(); boxtoggleP() }}>Update the problem</Button>{' '}
                    <Button color="danger" onClick={() => {cancelHandler(); boxtoggleP();}}>Cancel item</Button>
                    <Button color="secondary" onClick={boxtoggleP}>Close</Button>
                </ModalFooter> */}
      </Modal>
    </Row>
  );
};

export default BoxenAbholen;
